/**
 * RichText
 * @module components/RichText
 */

import { renderElementBasedOnEditMode } from 'common/helpers';
import { RichTextWrapper } from './RichText.styles';
import clsx from 'clsx';
import { useSiteType } from 'context/siteType.context';
import { useState } from 'react';
import ArticleDetail from 'components/common/ArticleDetail';

interface RichTextmodel {
	backgroundColor?: string;
	boldText?: any;
	footerCss?: any;
	text?: string;
	name?: string;
	size?: 'small' | 'large' | 'default';
	isInEditMode?: boolean;
	className?: string;
}

const RichText = (props: RichTextmodel) => {
	const {
		boldText,
		text,
		size,
		isInEditMode,
		name,
		className,
		footerCss,
	} = props;

	const siteType = useSiteType();

	const [articleModal, setArticleModal] = useState<{
		link: string | null;
		isActive: boolean;
	}>({
		link: null,
		isActive: false,
	});
	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		let el = e.target as HTMLElement;

		while (el && el.tagName !== 'A') {
			el = el.parentElement as HTMLElement;
		}

		if (el && el.tagName === 'A') {
			const link = el as HTMLAnchorElement;

			if (link.target === '_articleModal') {
				e.preventDefault();
				setArticleModal({ link: link.href, isActive: true });
			}
		}
	};

	return (
		<div onClick={handleClick}>
			{text
				? renderElementBasedOnEditMode(
						isInEditMode || false,
						name || '',
						RichTextWrapper,
						{
							className: clsx(
								className,
								siteType === 'LindabGroup' ? 'richtext-lg' : 'richtext'
							),
							size,
							boldText,
							footerCss,
							dangerouslySetInnerHTML: { __html: text },
						},
						//@ts-ignore
						null
				  )
				: null}
			{articleModal.isActive && (
				<ArticleDetail
					onToggle={() => setArticleModal({ link: null, isActive: false })}
					articleApiUrl={articleModal.link}
				/>
			)}
		</div>
	);
};

export default RichText;
